<script setup>
import { reactive, ref } from "vue";
import { ElMessage } from "element-plus";
import { queryUserRoleList } from "@/api/user";

const visible = ref(false);

const emit = defineEmits(["roleSelected"]);

// 遮罩
const loading = ref(true);

// 选中数据
const ids = ref([]);
// 总条数
const total = ref(0);

const tableRef = ref(null);

const reverseIds = ref([]);

// 角色列表数据
const roleList = ref([]);
// 查询参数
const queryParams = reactive({
  pageNum: 1,
  pageSize: 10,
  currentData: [],
});

/** 查询角色列表 */
const getList = () => {
  loading.value = true;
  queryUserRoleList({})
    .then((res) => {
      roleList.value = res.data;
      total.value = res.data.length;
    })
    .finally(() => {
      filterList();
      loading.value = false;
    });
};

// 分页
const filterList = () => {
  let startIndex = (queryParams.pageNum - 1) * 10; // 当前页数据的起始索引
  let endIndex = startIndex + 10 - 1; // 当前页数据的结束索引
  queryParams.currentData = roleList.value.slice(startIndex, endIndex + 1);

  reverseTable();
};

const handleSelectionChange = (selection) => {
  ids.value = selection.map((item) => item.roleCode);
};

/** 提交按钮 */
const submitForm = () => {
  if (ids.value.length > 1) {
    ElMessage.warning("只能选择一条");
    return false;
  }
  emit("roleSelected", ids.value[0]);
  visible.value = false;
};

// 弹窗打开
const handleDialogOpen = (config) => {
  tableRef.value?.clearSelection();
  reverseIds.value = config;
  visible.value = true;
  getList();
};

// 反选
const reverseTable = () => {
  queryParams.currentData.forEach((item) => {
    if (reverseIds.value.includes(item.roleCode)) {
      tableRef.value?.toggleRowSelection(item, true);
    }
  });
};

defineExpose({
  handleDialogOpen,
});
</script>

<template>
  <el-dialog
    width="900px"
    append-to-body
    v-model="visible"
    title="角色选择"
    :close-on-click-modal="false"
  >
    <el-table
      ref="tableRef"
      v-loading="loading"
      :data="queryParams.currentData"
      @selection-change="handleSelectionChange"
      row-key="roleCode"
    >
      <el-table-column
        type="selection"
        width="55"
        align="center"
        :reserve-selection="true"
      />
      <el-table-column label="角色编号" prop="roleCode" width="300" />
      <el-table-column
        label="角色名称"
        prop="roleName"
        :show-overflow-tooltip="true"
        width="150"
      />
      <el-table-column
        label="角色状态"
        prop="state.desc"
        :show-overflow-tooltip="true"
        width="150"
      />
      <el-table-column
        label="角色备注"
        prop="remark"
        :show-overflow-tooltip="true"
        width="150"
      />
    </el-table>

    <el-pagination
      v-show="total > 0"
      :total="total"
      v-model:current-page="queryParams.pageNum"
      @update:current-page="filterList"
      layout="->, prev, pager, next"
    />
    <template #footer>
      <el-button type="primary" @click="submitForm">确 定</el-button>
    </template>
  </el-dialog>
</template>

<style scoped>
.dialog-footer {
  position: absolute;
  top: 55px;
}
</style>
